export default __webpack_public_path__ + "static/media/union.7e0a267a.svg";